// feedback constants
export const ITEM_AT_BEST_PRICE = 'Product is already at it’s best price';

export const storeNames = {
  AJIO_STORE: 'ajio',
  LUXE_STORE: 'luxe',
  STREET_STORE: 'street'
};
